

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientMensturalParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface BleedingListOptions {
  value: string;
} 


export interface PatientMenstural {

  age: any;
  bleeding: any;
  frequency: any; 
  durationOfFlow: any;
  changesInRegularity: any;
  spotting: any;
  menstrualPain: any;
  mensesLastAnAverage: any;
  mensesAverageCycle: any;
  parameters?: PatientMensturalParameter[];
  links?: any;

}

export abstract class PatientMensturalData {
  abstract list(url: string): Observable<PatientMenstural[]>;
  abstract create(url: string, data: PatientMenstural): Observable<any>;
  abstract update(url: string, data: PatientMenstural): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
